export enum SystemUserType {
  Anonymous = 0,
  Authorised = 100
}



// WEBPACK FOOTER //
// ./src/shared/enum/systemUserType.ts